/* ================================
   MICHELLE FRANCISCO BEAUTY
   Fashion UX Enhancements
================================ */

(function () {
  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
  createBackToTop();
  polishSoldOutCards();
  addLuxuryTrustBar();
});

  function createBackToTop() {
    const btn = document.createElement('button');
    btn.className = 'mfb-back-to-top';
    btn.innerHTML = '↑';
    btn.setAttribute('aria-label', 'Back to top');

    const style = document.createElement('style');
    style.innerHTML = `
      .mfb-back-to-top {
        position: fixed;
        right: 18px;
        bottom: 22px;
        width: 44px;
        height: 44px;
        border-radius: 999px;
        border: 1px solid rgba(0,0,0,0.12);
        background: #111;
        color: #fff;
        font-size: 18px;
        z-index: 90;
        opacity: 0;
        pointer-events: none;
        transition: all .25s ease;
        box-shadow: 0 14px 30px rgba(0,0,0,.18);
      }
      .mfb-back-to-top.is-visible {
        opacity: 1;
        pointer-events: auto;
      }
      .mfb-back-to-top:hover {
        transform: translateY(-2px);
      }
    `;
    document.head.appendChild(style);
    document.body.appendChild(btn);

    window.addEventListener('scroll', function () {
      if (window.scrollY > 500) btn.classList.add('is-visible');
      else btn.classList.remove('is-visible');
    });

    btn.addEventListener('click', function () {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
  }

  function polishSoldOutCards() {
    document.querySelectorAll('.badge').forEach(function (badge) {
      const text = badge.textContent.trim().toLowerCase();
      if (text.includes('sold')) {
        badge.textContent = 'Sold Out';
      }
      if (text.includes('sale')) {
        badge.textContent = 'Sale';
      }
    });
  }

  function addLuxuryTrustBar() {
  const main = document.querySelector('main, #MainContent');
  if (!main) return;
  if (document.querySelector('.mfb-trust-bar')) return;

  const bar = document.createElement('section');
  bar.className = 'mfb-trust-bar';
  bar.innerHTML = `
  <a class="mfb-trust-bar__item" href="/collections/all-products">
    <strong>AI Curated Style</strong>
    <span>Shop the latest M Collection edits</span>
  </a>

  <a class="mfb-trust-bar__item" href="/cart">
    <strong>Secure Checkout</strong>
    <span>Review your bag safely</span>
  </a>

  <a class="mfb-trust-bar__item" href="/policies/shipping-policy">
    <strong>Global Delivery</strong>
    <span>M Collection ships to 44 supported countries</span>
  </a>

  <a
    class="mfb-trust-bar__item"
              href="https://jeepney.io/mfb-affiliate-signup.php"
    target="_blank"
    rel="noopener noreferrer"
  >
    <strong>Ambassador Rewards</strong>
    <span>Earn 10% by sharing M Collection</span>
  </a>
`;

  const style = document.createElement('style');
  style.innerHTML = `
    .mfb-trust-bar {
      display: grid;
      grid-template-columns: repeat(4, 1fr);
      gap: 1px;
      background: rgba(0,0,0,.08);
      border-top: 1px solid rgba(0,0,0,.08);
      border-bottom: 1px solid rgba(0,0,0,.08);
      margin: 0 auto 36px;
      max-width: 1380px;
    }

    .mfb-trust-bar__item {
      background: #fffaf4;
      text-align: center;
      padding: 14px 12px;
      text-decoration: none;
      color: #111;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      min-height: 72px;
      transition: all .2s ease;
    }

    text-decoration: none;
display: flex;
flex-direction: column;
align-items: center;
justify-content: center;

    .mfb-trust-bar__item strong {
      display: block;
      font-size: 11px;
      letter-spacing: .14em;
      text-transform: uppercase;
      font-weight: 600;
      margin-bottom: 4px;
    }

    .mfb-trust-bar__item span {
      display: block;
      font-size: 12px;
      letter-spacing: 0;
      text-transform: none;
      color: #6d6278;
      line-height: 1.4;
    }

    .mfb-trust-bar__item:hover {
      background: #f8f2ff;
      color: #7e62b1;
    }

    .mfb-trust-bar__item:hover span {
      color: #7e62b1;
    }

    @media (max-width: 749px) {
      .mfb-trust-bar {
        grid-template-columns: repeat(2, 1fr);
      }

      .mfb-trust-bar__item {
        min-height: 82px;
        padding: 12px 10px;
      }

      .mfb-trust-bar__item strong {
        font-size: 10px;
      }

      .mfb-trust-bar__item span {
        font-size: 11px;
      }
    }
  `;
  document.head.appendChild(style);
  main.prepend(bar);
}
})();